import {
  Form,
  Input,
  Checkbox,
  Link,
  Button,
  Space,
  Message
} from '@arco-design/web-react';
import { FormInstance } from '@arco-design/web-react/es/Form';
import { IconLock, IconUser } from '@arco-design/web-react/icon';
import React, { useEffect, useRef,Dispatch,SetStateAction,useState } from 'react';
// import axios from 'axios';
import axiosInstance from '@/utils/axiosInstance';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
// import 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js';

interface registerProp{
	setisShowLogin:Dispatch<SetStateAction<boolean>>;
	setisShowRegist:Dispatch<SetStateAction<boolean>>;
	aliCaptchaPrefix: string;
	aliCaptchaSceneIdWeb: string;
}
declare global {
  interface Window {
   setisShowRegist:any;
  }
}
export default function LoginForm(prop:registerProp) {
	const formRef = useRef<FormInstance>();
	const [form] = Form.useForm();
	const [errorMessage, setErrorMessage] = useState('');
	const [loading, setLoading] = useState(false);
	const [qcodebtn,setqcodebtn] = useState(false);
	const rcodebtn = useRef(false);
	const [qphone,setqphone] =  useState('');
	const rphone = useRef('');
	const [imgCode,setimgCode] = useState('');
	const [timeText,settimeText] = useState('获取验证码');
	const [timeNum,settimeNum] = useState(0);
	const rtimeNume = useRef(0);
	const [isRunning,setisRunning] = useState(false);
	const t = useLocale(locale);
	
	const [captchaImg,setcaptchaImg] = useState('');
	const [captchaUniqid,setcaptchaUniqid] = useState('');
	

	//  useEffect(()=>{
	// 	 getCaptcha();
	//  },[])

	// function getCaptcha() {
	// 	axiosInstance.get('/system/captcha')
	// 	.then((res) => {
	// 		const { code, msg } = res.data;
	// 		if (res.data.code === 0) {
	// 			setcaptchaImg(res.data.data.image)
	// 			setcaptchaUniqid(res.data.data.uniqid)

	// 		}else{
	// 			Message.error(msg)
	// 		}
	// 	})
	// }
  
  function afterLoginSuccess(params,token,role) {

    // 记录登录状态

    localStorage.setItem('userStatus', 'login');
	localStorage.setItem('username', params.phone);
	localStorage.setItem('token', token);
	localStorage.setItem('role', role);
    // 跳转首页
    window.location.href = '/home';
  }

  function register(params) {
    setErrorMessage('');
    setLoading(true);
	const item = JSON.parse(localStorage.getItem('inviteCode'));
	if (item && new Date().getTime() < item.expiration) { 
		params.invite_code = item.value;
	}
	  
	
    axiosInstance.post('/register/handler', params)
      .then((res) => {
        const { code, msg } = res.data;
        if (res.data.code === 0) {
			Message.success('注册成功');
			afterLoginSuccess(params,res.data.data.token,res.data.data.role);
        } else {
			setErrorMessage(msg);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function onSubmitClick() {
    formRef.current.validate().then((values) => {
      register(values);
    });
  }
  useEffect(() => {
    let countdown;
    if (isRunning && timeNum > 0) {
      countdown = setTimeout(() => {
		  settimeNum(timeNum - 1)
		  rtimeNume.current = timeNum - 1
		  settimeText(String(timeNum)+'s后重发')
	  }, 1000);
    } else if (timeNum === 0) {
      setisRunning(false);
	  settimeText('获取验证码')
	  
      // 在这里可以执行发送验证码的操作
    }
    return () => clearTimeout(countdown);
  }, [isRunning, timeNum]);
	
	// function smsSend(){
		
	// 		// form.getFieldsValue()
	// 		console.log('imgCode',imgCode);
	// 		const params = {
	// 			phone:qphone,
	// 			method:'register',
	// 			code:imgCode,
	// 			uniqid:captchaUniqid
	// 		}
	// 		axiosInstance.post('/sms/send', params)
	// 		  .then((res) => {
	// 		    const { code, msg } = res.data;
	// 		    if (res.data.code === 0) {
	// 				settimeNum(60);
	// 				setisRunning(true)
	// 				 setErrorMessage('');
	// 		    } else {
	// 				if(res.data.code==90010){
	// 					getCaptcha();
	// 				}
	// 		      setErrorMessage(msg);
	// 		    }
	// 		  })
	// 		  .finally(() => {
	// 		    setLoading(false);
	// 		  });
			  
			  
	//}
	// function smsSend1(){
		
	// 		// form.getFieldsValue()
	// 		console.log('imgCode',imgCode);
	// 		const params = {
	// 			phone:qphone,
	// 			method:'register',
	// 			code:imgCode,
	// 			uniqid:captchaUniqid
	// 		}
	// 		axiosInstance.post('/sms/send', params)
	// 		  .then((res) => {
	// 		    const { code, msg } = res.data;
	// 		    if (res.data.code === 0) {
	// 				settimeNum(60);
	// 				setisRunning(true)
	// 				 setErrorMessage('');
	// 		    } else {
					
	// 		      setErrorMessage(msg);
	// 		    }
	// 		})
	// 		  .finally(() => {
	// 		    setLoading(false);
	// 		});
			  
			  
	// }
	// const cImgCode = (e)=>{
	// 	setimgCode(e)
	// }
	const cphone = (e)=>{
			if(e.length==11){
				setqcodebtn(true);
				rcodebtn.current = true;
			}else{
				setqcodebtn(false);
				rcodebtn.current = false;
			}
			setqphone(e)
			rphone.current = e
	}
	
    let captcha;

    const getInstance = (instance) => {
        captcha = instance;
    };

    const captchaVerifyCallback = async (captchaVerifyParam) => {
		if(!rcodebtn.current||rtimeNume.current>0){
			return {
			    captchaResult: true,
				bizResult: true
			}
		}
		const res = await axiosInstance.post('/sms/send_v2', {
			method:'register',
			captchaVerifyParam:JSON.parse(captchaVerifyParam),
			phone:rphone.current,
		})

		let captchaResult = false;
		let bizResult = false;
		    if (res.data.code === 0) {
				settimeNum(60);
				rtimeNume.current=60
				setisRunning(true)
				setErrorMessage('');
				captchaResult = true;
				bizResult = true;
			
		    } else {
				if (res.data.code === 90011) {
					captchaResult = false;
					bizResult = false;
					
				}else{
					setErrorMessage(res.data.msg);
					captchaResult = true;
					bizResult = true;
				}
			}
		return {
		    captchaResult: captchaResult,
		    bizResult: bizResult,
		}
		
       
    }
      // 验证通过后调用
    const onBizResultCallback = ()  => {
        console.log('onBizResultCallback');
    }

    useEffect(() => {
		// axiosInstance.get('/system/config')
		//   .then((res) => {
		//     if (res.data.code === 0) {
					(window as any).initAliyunCaptcha({
						SceneId: prop.aliCaptchaSceneIdWeb, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
						prefix: prop.aliCaptchaPrefix, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
						mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
						element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
						button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
						captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
						onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
						getInstance: getInstance, // 绑定验证码实例函数，无需修改
						slideStyle: {
							width: 360,
							height: 40,
						}, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
						language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
					});
				 		
		//     }
		// })

        return () => {
            // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
        document.getElementById('aliyunCaptcha-mask')?.remove();
        document.getElementById('aliyunCaptcha-window-popup')?.remove();
        }
    }, []);

  return (
    <div className={styles['login-form-wrapper']}>
      <div className={styles['login-form-title']}>注册</div>
      <div className={styles['login-form-sub-title']}>
		 
      </div>
      <div className={styles['login-form-error-msg']}>{errorMessage}</div>
      <Form
		form={form}
        className={styles['login-form']}
        layout="inline"
        ref={formRef}
        initialValues={{ phone: '', password: '', sms_code:'' }}

      >
        <Form.Item
          field="phone"
          rules={[{ required: true, message:'登录手机号不能为空' }]}
			style={{marginBottom:20}}
        >
          <Input
            prefix={<IconUser />}
			style={{width:320}}
			onChange={(e)=>cphone(e)}
            placeholder='登录手机号'
          />
        </Form.Item>
		
		{/*
		<Form.Item
		  field="send_code"
		  rules={[{ required: true, message: '图形验证码不能为空'}]}
		>
		<Input
			style={{width:180}}
			placeholder='请输入图形验证码'
			onChange={(e)=>cImgCode(e)}
		  />
		 
		</Form.Item>
		{captchaImg!='' &&(
			<div style={{marginLeft:15,width1764:100,height:28}} onClick={()=>getCaptcha()} >
				<img style={{width:100,height:28}}  src={captchaImg} />
			</div>
		)}
		*/}


		<Form.Item
		  field="sms_code"
		  rules={[{ required: true, message: '验证码不能为空'}]}
		  
		>
		  <Input
			style={{width:180}}
			placeholder='验证码'
		  />
		 
		</Form.Item>
		
		{/*
		<Button style={{marginLeft:15,width:100,textAlign:'center'}}  onClick={()=>smsSend1()}  disabled={!qcodebtn||timeNum>=1} type='primary'>{timeText}</Button>
		*/} 

		 <div id="captcha-button" style={{display:timeNum<=1?'block':'none'}}  className={!qcodebtn||timeNum>=1?styles['ewei-btn-dis']:styles['ewei-btn']} >{timeText}</div>
		 <div id="captcha-element"></div>
		 
		 <div style={{display:timeNum>1?'block':'none'}}  className={!qcodebtn||timeNum>=1?styles['ewei-btn-dis']:styles['ewei-btn']} >{timeText} </div>
		 
        <Form.Item
          field="password"
          rules={[{ required: true, message: '密码不能为空'}]}
		  style={{marginTop:10,marginBottom:20}}
        >
          <Input.Password
		  style={{width:320}}
            prefix={<IconLock />}
			placeholder='登录密码'
          />
        </Form.Item>
        <Space size={16} direction="vertical">
          <Button type="primary" long onClick={onSubmitClick} loading={loading} style={{width:320}}>
            注册
          </Button>
          <Button
            type="text"
            long
            className={styles['login-form-register-btn']}
			onClick={()=>{
				prop.setisShowRegist(false);
				prop.setisShowLogin(true)
			}}
			style={{width:320}}
          >
            去登录
          </Button>
        </Space>
      </Form>
    </div>
  );
}
